import { Box, Button, InputAdornment, Stack, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import EventCard from "./EventCard";
import EventEdit from "./EventEdit";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import ThriveModal from "../../common/ThriveModal";
import ThriveCaseSelection from "../../common/ThriveCaseSelection";
import NoticeDialog from "../../common/NoticeDialog";
import { StyledButton } from "../../common/Buttons";
import { NavLink } from "react-router-dom";
import { EventType } from "../../../interfaces";
import EmailEditor from "../../common/EmailEditor";
import { EventInvitation } from "../../common/EmailBodies/EventInvitation";
import { axiosInstance, fetchInstance } from "../../../utils/networking";
const Events = (props: any) => {
  const [eventEmailTos, setEventEmailTos] = useState([]);
  const [checkedCases, setCheckedCases] = useState<string[]>([]);
  const [selectedCase, setSelectedCase] = useState<any>({ firmRecord: {} });
  const [availableEvents, setAvailableEvents] = useState<EventType[]>([]);
  const [displayEvents, setDisplayEvents] = useState<EventType[]>([]);
  const [selectedEvent, setSelectedEvent] = useState("");
  const [invitationOpen, setInvitationOpen] = useState(false);
  const [editorOpen, setEditorOpen] = useState(false);
  const [messageOpen, setMessageOpen] = useState(false);
  const [messageTitle, setMessageTitle] = useState("");
  const [messageBody, setMessageBody] = useState("");
  const [dataFlag, setDataFlag] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [editingEvent, setEditingEvent] = useState<EventType | null>(null);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [deletingEvent, setDeletingEvent] = useState<EventType | null>(null);
  const [searchTerm, setSearchTerm] = useState("");

  const loadEvents = () => {
    axiosInstance.get(`/events`).then((res) => {
      setAvailableEvents(res.data.events || []);
      applySearch(res.data.events || [], searchTerm);
    });
  };
  useEffect(() => {
    axiosInstance.get(`/events`).then((res) => {
      setAvailableEvents(res.data.events || []);
      setDisplayEvents(res.data.events || []);
    });
  }, []);

  const applySearch = (events: EventType[], term: string) => {
    const q = term.toLowerCase();
    setDisplayEvents(
      events.filter((event: EventType) => {
        return ((event.name?.text || "") + (event.description?.text || ""))
          .toLowerCase()
          .includes(q);
      })
    );
  };

  const handleEventSearch = (e: any) => {
    setSearchTerm(e.target.value);
    applySearch(availableEvents, e.target.value);
  };

  const handleSendInvitation = () => {
    setInvitationOpen(false);
    setEditorOpen(true);
  };

  const handleAddEvent = () => {
    setEditingEvent(null);
    setEditOpen(true);
  };

  const handleEditEvent = (event: EventType) => {
    setEditingEvent(event);
    setEditOpen(true);
  };

  const handleDeleteEvent = (event: EventType) => {
    setDeletingEvent(event);
    setDeleteOpen(true);
  };

  const confirmDelete = () => {
    if (!deletingEvent?._id) return;
    axiosInstance
      .delete(`/events?id=${deletingEvent._id}`)
      .then(() => {
        setDeleteOpen(false);
        setDeletingEvent(null);
        loadEvents();
      });
  };

  return (
    <Box>
      <Stack direction={"row"} spacing={2}>
        {/* <Box sx={{ width: "30%" }}>
          <Stack>
            <Box>Tag Search Bar</Box>

            <Box>Tag List</Box>
          </Stack>
        </Box> */}

        <Box sx={{ width: "100%" }}>
          <Stack spacing={2}>
            <TextField
              label="Search Events..."
              variant="outlined"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              onChange={handleEventSearch}
            ></TextField>
            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}
            >
              <NavLink to="/dashboard/pastevents">
                <Button sx={{ color: "#b3197a" }}>
                  Past Events and Surveys
                </Button>
              </NavLink>
              <StyledButton
                variant="contained"
                startIcon={<AddIcon />}
                onClick={handleAddEvent}
              >
                Add Event
              </StyledButton>
            </Stack>

            {/* <Box>Event Category</Box> */}
            <Stack>
              {displayEvents.map((event: EventType, index: number) => {
                return (
                  <EventCard
                    key={index}
                    event={event}
                    displayButton={true}
                    setInvitationOpen={setInvitationOpen}
                    setSelectedEvent={setSelectedEvent}
                    onEdit={handleEditEvent}
                    onDelete={handleDeleteEvent}
                  ></EventCard>
                );
              })}
            </Stack>
          </Stack>
        </Box>
      </Stack>
      <ThriveModal
        open={invitationOpen}
        setOpen={setInvitationOpen}
        closeByClick={true}
        contentComponent={
          <ThriveCaseSelection
            height={400}
            cases={[]}
            reloadCases={true}
            checkedCases={checkedCases}
            setCheckedCases={setCheckedCases}
            selectedCase={selectedCase}
            setSelectedCase={setSelectedCase}
            setOpen={setInvitationOpen}
            enableControl={true}
            enableSelection={true}
            enableMultiSelection={true}
            title={"Send Event Invitation"}
            status_default="either"
            sortby_default="recent"
            period_default="all"
            handleNext={handleSendInvitation}
            setEventEmailTos={setEventEmailTos}
          ></ThriveCaseSelection>
        }
      ></ThriveModal>
      <ThriveModal
        height={750}
        open={editorOpen}
        setOpen={setEditorOpen}
        closeByClick={true}
        contentComponent={
          <EmailEditor
            setOpen={setEditorOpen}
            theCase={{}}
            theFirm={{}}
            theReferral={{}}
            editorTitle={"Event Invitation"}
            theSubject={"Event Invitation"}
            theSelectedEvent={selectedEvent}
            theSelectedProvider={{}}
            bodyGenerator={EventInvitation}
            setMessageOpen={setMessageOpen}
            setMessageTitle={setMessageTitle}
            setMessageBody={setMessageBody}
            eventEmailTos={eventEmailTos}
            theBFC={{}}
          ></EmailEditor>
        }
      ></ThriveModal>
      <ThriveModal
        open={messageOpen}
        setOpen={setMessageOpen}
        closeByClick={true}
        height={200}
        width={500}
        contentComponent={
          <NoticeDialog
            title={"Email Sent!"}
            setOpen={setMessageOpen}
            setDataFlag={setDataFlag}
          ></NoticeDialog>
        }
      ></ThriveModal>
      <ThriveModal
        open={editOpen}
        setOpen={setEditOpen}
        closeByClick={true}
        height={"90vh"}
        contentComponent={
          <EventEdit
            event={editingEvent}
            setOpen={setEditOpen}
            onSaved={loadEvents}
          ></EventEdit>
        }
      ></ThriveModal>
      <ThriveModal
        open={deleteOpen}
        setOpen={setDeleteOpen}
        closeByClick={true}
        height={220}
        width={500}
        contentComponent={
          <Box sx={{ padding: "24px" }}>
            <Box sx={{ fontWeight: "bold", fontSize: "18px", mb: 1 }}>
              Delete Event
            </Box>
            <Box sx={{ color: "gray", mb: 3 }}>
              Delete "{deletingEvent?.name?.text}"? It will be removed from the
              events list.
            </Box>
            <Stack direction={"row"} spacing={2} justifyContent={"flex-end"}>
              <StyledButton onClick={() => setDeleteOpen(false)}>
                Cancel
              </StyledButton>
              <StyledButton
                variant="contained"
                color="error"
                onClick={confirmDelete}
              >
                Delete
              </StyledButton>
            </Stack>
          </Box>
        }
      ></ThriveModal>
    </Box>
  );
};

export default Events;
